import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'

export default function useCompletedProjects() {
  const [projects, setProjects] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    async function fetchCompletedProjects() {
      try {
        setLoading(true)
        setError(null)

        // Filter for completed projects from the same table
        const { data, error: fetchError } = await supabase
          .from('ongoing_projects')
          .select('*')
          .in('status', ['Completed', 'Recently Completed'])
          .order('order_priority', { ascending: true })
          .order('created_at', { ascending: false }) // Order by creation date, newest first

        if (fetchError) {
          throw fetchError
        }

        // Transform the data to match the expected format
        const transformedProjects = data.map(project => ({
          Title: project.title,
          Status: project.status,
          'Award Number': project.award_number,
          Source: project.source,
          Place: project.place,
          'Start Date': project.start_date,
          'End Date': project.end_date,
          'Person-Months': project.person_months,
          Objectives: project.objectives,
          Overlap: project.overlap,
          Link: project.link,
          'Logo Source': project.logo_src,
          People: project.people,
          Outcomes: project.outcomes,
          id: project.id,
          createdAt: project.created_at,
          updatedAt: project.updated_at
        }))

        setProjects(transformedProjects)
      } catch (err) {
        console.error('Error fetching completed projects:', err)
        setError(err)
      } finally {
        setLoading(false)
      }
    }

    fetchCompletedProjects()
  }, [])

  return { projects, loading, error }
}
